import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Euro_md = (props) => {
    const width = props.width ? props.width + 'px' : '24px';
    const height = props.height ? props.height + 'px' : '24px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 24 24"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.06332 11C7.02162 11.3257 7 11.6595 7 12C7 12.3405 7.02162 12.6743 7.06332 13H13C13.5523 13 14 13.4477 14 14C14 14.5523 13.5523 15 13 15H7.60594C8.63273 17.3929 10.8459 19 13.3215 19C14.8324 19 16.228 18.4129 17.3275 17.4138C17.7362 17.0423 18.3687 17.0726 18.7401 17.4813C19.1115 17.8901 19.0813 18.5225 18.6725 18.8939C17.2347 20.2005 15.3686 21 13.3215 21C9.64585 21 6.60833 18.4591 5.47581 15H4C3.44772 15 3 14.5523 3 14C3 13.4477 3.44772 13 4 13H5.05128C5.01738 12.6711 5 12.3374 5 12C5 11.6626 5.01738 11.3289 5.05128 11H4C3.44772 11 3 10.5523 3 10C3 9.44772 3.44772 9 4 9H5.47581C6.60833 5.54093 9.64585 3 13.3215 3C15.3686 3 17.2347 3.79954 18.6725 5.10607C19.0813 5.47749 19.1115 6.10993 18.7401 6.51867C18.3687 6.92741 17.7362 6.95766 17.3275 6.58624C16.228 5.58709 14.8324 5 13.3215 5C10.8459 5 8.63273 6.60715 7.60594 9H13C13.5523 9 14 9.44772 14 10C14 10.5523 13.5523 11 13 11H7.06332Z"
            />
        </SvgStyled>
    );
};

export default Euro_md;
